import angular from 'angular'
import { EntityStore } from './entity-store'

export type ReceiptSettingsStore = EntityStore<'receiptSettings'>

/**
 * Stores information on the retailer's receipt settings.
 */
export const receiptSettingsStore: ReceiptSettingsStore = new EntityStore({
  entityStoreName: 'receiptSettings',
  entityName: 'receipt_settings',
  syncDeleted: false,
})

/**
 * Responsible for persisting storage of receipt settings from the /api/2.0/receipt_settings API endpoint into IndexedDB.
 *
 * @module receiptSettingsStore
 */
angular
  .module('webregister.factories')
  .constant('receiptSettingsStore', receiptSettingsStore)
